import { render, staticRenderFns } from "./SafetyReportDetails.vue?vue&type=template&id=149b1b58&scoped=true&"
import script from "./SafetyReportDetails.vue?vue&type=script&lang=js&"
export * from "./SafetyReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./SafetyReportDetails.vue?vue&type=style&index=0&id=149b1b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b1b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('149b1b58')) {
      api.createRecord('149b1b58', component.options)
    } else {
      api.reload('149b1b58', component.options)
    }
    module.hot.accept("./SafetyReportDetails.vue?vue&type=template&id=149b1b58&scoped=true&", function () {
      api.rerender('149b1b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/SafetyReportDetails.vue"
export default component.exports